export default {"src":"/_next/static/media/404.72a130f1.svg","height":214,"width":214};